import { render, staticRenderFns } from "./AccountClosure.vue?vue&type=template&id=387ba22a&scoped=true&"
import script from "./AccountClosure.vue?vue&type=script&lang=js&"
export * from "./AccountClosure.vue?vue&type=script&lang=js&"
import style0 from "./AccountClosure.vue?vue&type=style&index=0&id=387ba22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ba22a",
  null
  
)

export default component.exports